import { render, staticRenderFns } from "./flex-scroll-box.vue?vue&type=template&id=cc18af0c&"
import script from "./flex-scroll-box.vue?vue&type=script&lang=ts&"
export * from "./flex-scroll-box.vue?vue&type=script&lang=ts&"
import style0 from "./flex-scroll-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports